import React from 'react';
import { Flex, Heading, Image, Paragraph } from '@qga/roo-ui/components';

import Link from '@/components/Link';
import SimpleLayout from '@/components/SimpleLayout';
import alert from './assets/alert.svg';

const ErrorPage = () => (
  <>
    <SimpleLayout>
      <Flex
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        flex="1"
        bg="greys.porcelain"
        textAlign="center"
        px="5"
        py="10"
        minHeight="500px"
      >
        <Image height="53px" src={alert} alt="Alert" />
        <Heading.h4 mt="2">Sorry, something went wrong</Heading.h4>
        <Paragraph>
          We&apos;re aware that something isn&apos;t quite right and we&apos;re
          in the middle of fixing it.
        </Paragraph>
        <Paragraph mb="4">
          Please email&nbsp;
          <Link.Text external href="mailto:support@qantashotels.com">
            support@qantashotels.com
          </Link.Text>
          .
        </Paragraph>
      </Flex>
    </SimpleLayout>
  </>
);

export default ErrorPage;
